<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="matricula-nota-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">

                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="disciplinaIdMatricula" class="form-label"> Disciplina</label>
                                <input id="disciplinaIdMatricula" v-model="disciplinaFiltro" @keyup="apertouEnter"
                                    type="text" class="form-control form-control-solid" placeholder="Disciplina" />
                            </div>
                            <div class="col-12 col-md-6 col-lg-2" v-if="status">
                                <label for="statusMatriculaNota" class="form-label">Status</label>
                                <Multiselect id="statusMatriculaNota" v-model="status_id" :options="status_select"
                                    :searchable="true" @change="refreshTable" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="notaMinMatricula" class="form-label">Nota Min</label>
                                <input id="notaMinMatricula" v-model="notaMin" @keyup="apertouEnter" type="text"
                                    class="form-control form-control-solid" placeholder="Nota minima" />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="notaMaxMatricula" class="form-label">Nota Max</label>
                                <input id="notaMaxMatricula" v-model="notaMax" @keyup="apertouEnter" type="text"
                                    class="form-control form-control-solid" placeholder="Nota maxima" />
                            </div>
                            <div class="col-12 col-lg-3 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                                <button v-if="hasPermissaoEditar && matricula.status.id != 6 && hasPermissao"
                                    type="button" class="btn btn-sm btn-pmes-primary" title="Cadastrar"
                                    data-bs-toggle="modal" :data-bs-target="'#' + modal_cadastro_bota">
                                    <span class="menu-icon">
                                        <i class="fa fa-plus fa-2x bi"></i>
                                    </span>
                                    Cadastrar
                                </button>
                            </div>
                        </div>

                        <Cadastro @nota-matricula-criada="refreshTable" :matricula="matricula"
                            :modal="modal_cadastro_bota" :perfis="perfis" />
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false"
                            @tableatualizada="tableatualizada">
                            <th>Disciplina</th>
                            <th>Tipo</th>
                            <th>Nota</th>
                            <th>Status</th>
                            <th style="min-width:90px" class="text-center" v-if="hasPermissao">Acoes</th>
                        </KDataTable>
                    </section>
                </div>
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { namespace } from 'vuex-class';
import CardRh from "@/components/cards/ManzaCard.vue";
import NotaService from "@/service/v1/sigap/NotaService";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from '@vueform/multiselect';
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { User } from "@/store/modules/AuthModule";
import Cadastro from "./_Cadastro.vue";
import { Prop } from 'vue-property-decorator';
import $ from "jquery";

const authStore = namespace('auth');

@Options({
    name: "NotaMatriculaIndex",
    components: { CardRh, KDataTable, Multiselect, Cadastro },
})
export default class NotaMatriculaIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    @authStore.Getter
    public currentUser!: User;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public modelo: any = null;
    public dados: any = null;
    public status_id: any = null;
    public matriculaId: any = null;
    public status: any = null;
    public modal_cadastro_bota: any = 'kt_cadatrar_matricula_avaliacao';
    public search = '';
    public notaMin = '';
    public notaMax = '';
    public disciplinaFiltro = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.status_id = null;
        this.notaMin = '';
        this.notaMax = '';
        this.disciplinaFiltro = '';
        this.refreshTable();
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    pushColunaAcoes(): void {
        this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    created() {
        this.matriculaId = this.$route.params.id;
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new NotaService();
        this.getStatus();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    status: this.status_id,
                    matriculaId: this.matriculaId,
                    disciplina: this.disciplinaFiltro,
                    notaMax: this.notaMax,
                    notaMin: this.notaMin,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[0, 'asc'],[1, 'asc']];
        this.config.columns = [
            { data: 'disciplina.descricao', name: 'disciplina' },
            { data: 'tipo', name: 'tipo' },
            { data: 'notaValor', name: 'notavalor' },
            { data: 'status', name: 'status ' },
        ];

        this.config.columnDefs = [
            {
                targets: 1,
                render: (row) => {
                    return row.nome.replaceAll('_', ' ');
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return row.nome.replaceAll('_', ' ');
                }
            },
        ];

        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push({
                targets: 4,
                render: (row, type, val) => {
                    let texto = '';
                    let buttom = '';
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-nota ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                    return texto;
                },
            });
        }
    }

    public tableatualizada(): void {
        $('[btn-show-nota]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            const routeData = this.$router.resolve({ name: 'sigap_avaliacao_show', params: { id: id } });
            window.open(routeData.href, '_blank');
        });
    }
}
</script>

<style scoped>
.matricula-nota-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

.registro-alteracao {
    text-align: right;
}

.card-header {
    min-height: 50px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
